import actionTypes from '../constants/action-types';

const showEditor = () => ({
  type: actionTypes.SHOW_EDITOR,
});

export default showEditor;
